import React from 'react';
import { Plus, ImageOff } from 'lucide-react';
import { Product } from '../types';

interface ProductCardProps {
  product: Product;
  onClick: (product: Product) => void;
}

export const ProductCard: React.FC<ProductCardProps> = ({ product, onClick }) => {
  if (!product) return null;

  // Safe image access
  const imageSrc = product.images && product.images.length > 0 ? product.images[0] : null;

  return (
    <div onClick={() => onClick(product)} className="group bg-white rounded-lg shadow-sm hover:shadow-lg transition-all duration-300 overflow-hidden border border-gray-100 flex flex-col h-full cursor-pointer">
      <div className="relative aspect-[4/5] overflow-hidden bg-gray-100 flex items-center justify-center">
        {imageSrc ? (
            <img
            src={imageSrc}
            alt={product.name || 'Product'}
            className="object-cover w-full h-full transform group-hover:scale-110 transition-transform duration-500"
            loading="lazy"
            onError={(e) => {
                // Fallback on error
                (e.target as HTMLImageElement).src = 'https://placehold.co/400x500?text=No+Image';
            }}
            />
        ) : (
            <div className="flex flex-col items-center text-gray-400">
                <ImageOff size={32} />
                <span className="text-xs mt-1">No Image</span>
            </div>
        )}
        
        {product.discountPrice && (
            <div className="absolute top-2 left-2 bg-red-600 text-white text-xs font-bold px-2 py-1 rounded z-10">
                SALE
            </div>
        )}
      </div>
      
      <div className="p-4 flex flex-col flex-grow">
        <div className="text-xs font-semibold text-gray-400 uppercase tracking-wider mb-1">
          {product.category || 'Uncategorized'}
        </div>
        <h3 className="text-sm font-bold text-gray-900 mb-1 line-clamp-1" title={product.name}>
          {product.name || 'Unnamed Product'}
        </h3>
        
        <div className="flex items-center gap-2 mt-auto">
          <span className="text-base font-bold text-gray-900">
            Rs. {(product.discountPrice || product.price || 0).toLocaleString()}
          </span>
          {product.discountPrice && (
             <span className="text-xs text-gray-400 line-through">
                Rs. {(product.price || 0).toLocaleString()}
             </span>
          )}
        </div>
      </div>
    </div>
  );
};